import { RouteObject } from 'react-router-dom'
import { CreateServiceModal } from '../pages/create'
import { ServicePage } from '../pages/service'
import { ServicesPage } from '../pages/services'
import { EditPricingModal } from '../pages/variants/edit-pricing'
import { EditServiceDetailsModal } from '../pages/edit-service-details'
import { EditServiceInfoModal } from '../pages/edit-service-info'

export enum ServiceRoutePath {
  Services = '/services',
  ServiceCreate = '/services/create',

  ServicesView = '/services/:id',
  ServicesViewEdit = 'edit',
  ServicesViewEditInfo = 'edit-info',
  ServicesViewPricingEdit = 'pricing/edit',
}

export const protectedServiceRoutes: RouteObject[] = [
  {
    path: ServiceRoutePath.Services,
    element: <ServicesPage />,
    children: [
      {
        path: ServiceRoutePath.ServiceCreate,
        element: <CreateServiceModal />,
      },
    ],
  },
  {
    path: ServiceRoutePath.ServicesView,
    element: <ServicePage />,
    children: [
      {
        path: ServiceRoutePath.ServicesViewEdit,
        element: <EditServiceDetailsModal />,
      },
      {
        path: ServiceRoutePath.ServicesViewEditInfo,
        element: <EditServiceInfoModal />,
      },
      {
        path: ServiceRoutePath.ServicesViewPricingEdit,
        element: <EditPricingModal />,
      },
    ],
  },
]
